'use strict'

import cryptoJs from 'crypto-js'

export default {
  jiemi (word) {
    var key = '5678efghEFGH!@#$%^&*()-+';
    var iv  = '2defghijklmnopq3';
    var text = cryptoJs.AES.decrypt(word.ciphertext,
                cryptoJs.enc.Utf8.parse(key),
                {   mode: cryptoJs.mode.CFB,
                    iv: cryptoJs.enc.Utf8.parse(iv),
                    padding: cryptoJs.pad.NoPadding   }).toString(cryptoJs.enc.Utf8);
    var pcnt = text.charCodeAt(text.length-1);
    var data = JSON.parse(text.substr(0, text.length-pcnt));
    return data
  }
}